import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: ${props => props.size ? props.size : '20px'};
  height: ${props => props.size ? props.size : '20px'};
  position: relative;
  margin: ${props => props.noMargin ? '0' : '50px auto'};

  background-color: transparent;
  border-top: ${props => props.borderWidth ? props.borderWidth : '1px'} solid ${props => props.color ? props.color : theme.colors.green.Verde_AgroReceita};
  border-bottom: ${props => props.borderWidth ? props.borderWidth : '1px'} solid ${props => props.color ? props.color : theme.colors.green.Verde_AgroReceita};
  border-left: ${props => props.borderWidth ? props.borderWidth : '1px'} solid transparent;
  border-right: ${props => props.borderWidth ? props.borderWidth : '1px'} solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;
